module.exports = __webpack_public_path__ + "media/images/icons/country_flags/es-e3471d73993a1d499c2ab07fe350185e.svg";